import { render, staticRenderFns } from "./ArrangeProcesses.vue?vue&type=template&id=4e484043&scoped=true&"
import script from "./ArrangeProcesses.vue?vue&type=script&lang=js&"
export * from "./ArrangeProcesses.vue?vue&type=script&lang=js&"
import style0 from "./ArrangeProcesses.vue?vue&type=style&index=0&id=4e484043&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e484043",
  null
  
)

export default component.exports